var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AudienceForm',{attrs:{"pixels-list":_vm.pixels,"site-times":_vm.siteTimes,"load-data":_vm.loadData,"page-name":_vm.$tc('pages.audienceForm.title', 2)},on:{"submit":_vm.updateAudience,"setBackUrl":_vm.setBackUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }